import { getCookie } from './cookies';

const TERMS_ACCEPTED = 'cookie_terms_accepted';

class CookieBannerUtils {
  static get isAccepted() {
    return getCookie(TERMS_ACCEPTED) === 'true';
  }
}

export default CookieBannerUtils;
